"use client";

import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

/**
 * A safe wrapper around useSearchParams that handles Suspense boundary requirements
 * This hook will not suspend and returns undefined until searchParams are available
 */
export function useSafeSearchParams() {
    const [mounted, setMounted] = useState(false);
    
    useEffect(() => {
        setMounted(true);
    }, []);

    try {
        const searchParams = useSearchParams();
        return mounted ? searchParams : null;
    } catch {
        // If useSearchParams throws (like during SSR or when not in Suspense boundary),
        // return null to prevent the error
        return null;
    }
}

/**
 * Alternative hook that returns URLSearchParams directly without Next.js wrapper
 * Use this when you need immediate access to search params without Suspense
 */
export function useURLSearchParams() {
    if (typeof window === 'undefined') {
        return null;
    }

    return new URLSearchParams(window.location.search);
}
